import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=55c5c32e&"
import script from "./Bread.vue?vue&type=script&lang=js&"
export * from "./Bread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports